import { InvocationState } from './InvocationState';

export const inProgressInvocationStates: InvocationState[] = [
  'NEW',
  'WAITING_FOR_FETCH'
];
